class HHRecoverForm extends HTMLElement {
  constructor() {
    super()

    this.$submit = this.querySelector('.js-recover-submit')
    this.$recoverForm = this.querySelector('#recover_password')

    this.email = this.querySelector('#RecoverEmail')
    this.emailError = this.querySelector('.js-RecoverEmail')
  }

  connectedCallback() {
    this.$submit.addEventListener('click', this.recoverFormSubmit.bind(this))
  }

  validateEmail(elementValue) {
    const mailformat = /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
    return elementValue.match(mailformat)
  }

  recoverFormSubmit(event) {
    event.preventDefault()

    let valid = true

    if (this.email.value === '') {
      this.emailError.classList.remove('hidden')
      this.emailError
        .querySelectorAll('span')
        .forEach((item) => item.classList.remove('hidden'))
      this.emailError.querySelector('.js-error-matched').classList.add('hidden')
      if (valid) {
        this.emailError
          .querySelector('.customer__inner-form-error-wrap')
          .focus()
        valid = false
      }
    } else if (
      this.email.value !== '' &&
      !this.validateEmail(this.email.value)
    ) {
      this.emailError.classList.remove('hidden')
      this.emailError
        .querySelectorAll('span')
        .forEach((item) => item.classList.remove('hidden'))
      this.emailError
        .querySelector('.js-error-required')
        .classList.add('hidden')
      if (valid) {
        this.emailError
          .querySelector('.customer__inner-form-error-wrap')
          .focus()
        valid = false
      }
    } else {
      this.emailError.classList.add('hidden')
    }

    if (!valid) {
      event.preventDefault()
    } else {
      this.$recoverForm.submit()
    }
  }
}

customElements.define('hh-recover-form', HHRecoverForm)
